import axios from "../../services/axios";

interface GetAllParams {
  query: any;
}

const UserService = {
  getAll: async ({ query }: GetAllParams) => {
    try {
      const res = await axios.get(`/users?${query}`);

      return {
        data: res.data,
      };
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },
  getTotalUserCount: async () => {
    try {
      const res = await axios.get(`/users/count`);
      return res.data;
    } catch (error) {
      console.error("Error fetching users count:", error);
      throw error;
    }
  },
};

export default UserService;
